module.exports = __webpack_public_path__ + "img/midland-auto-sales-hamilton-leicester-1920x830.7dda1ee2.jpg";